import React, { useState, useEffect } from 'react';
import logo from './Mart-POS-Lite.png';
export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const nav = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const links = [
    { label: 'Products', id: 'products' },
    { label: 'Features', id: 'features' },
    { label: 'Modules', id: 'modules' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 600,
      background: scrolled ? 'rgba(6,13,26,0.96)' : 'transparent',
      backdropFilter: scrolled ? 'blur(16px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
      transition: 'all 0.3s ease',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 70 }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img
            src={logo}
            alt="Mart CMS Logo"
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              objectFit: 'contain',
            }}
          />
          <div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: 800, fontSize: 17, color: 'white', letterSpacing: '-0.4px', lineHeight: 1.1 }}>
              Mart<span style={{ color: '#60a5fa' }}>CMS</span> & POS-Lite
            </div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.35)', letterSpacing: '1.2px', textTransform: 'uppercase', fontWeight: 500 }}>Retail Platform</div>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: 28 }} className="desktop-nav">
          {links.map(l => (
            <button key={l.id} className="nav-link" onClick={() => nav(l.id)}>{l.label}</button>
          ))}
        </nav>

        {/* CTA */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="btn btn-blue btn-sm" onClick={() => nav('contact')}>Book a Demo</button>
          <button className="hamburger" onClick={() => setMenuOpen(o => !o)} style={{
            background: 'none', border: '1.5px solid rgba(255,255,255,0.2)',
            borderRadius: 8, padding: '8px 10px', color: 'white', fontSize: 16, display: 'none',
          }}>{menuOpen ? '✕' : '☰'}</button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{ background: 'rgba(6,13,26,0.98)', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '12px 20px 20px' }}>
          {links.map(l => (
            <button key={l.id} onClick={() => nav(l.id)} style={{
              display: 'block', width: '100%', padding: '13px 0', background: 'none',
              color: 'rgba(255,255,255,0.8)', fontSize: 15, fontWeight: 500,
              borderBottom: '1px solid rgba(255,255,255,0.05)', textAlign: 'left', cursor: 'pointer',
            }}>{l.label}</button>
          ))}
          <button className="btn btn-blue" style={{ width: '100%', justifyContent: 'center', marginTop: 16 }}
            onClick={() => nav('contact')}>Book a Free Demo</button>
        </div>
      )}

      <style>{`
        @media(max-width:800px){.desktop-nav{display:none!important}.hamburger{display:flex!important}}
      `}</style>
    </header>
  );
}
